import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';
import MuiTypography from '@mui/material/Typography';
import { keyframes } from '@mui/system';

const Root = styled(MuiBox, {
    shouldForwardProp: prop => !['count', 'rtl'].includes(prop),
}) `
  ${({ theme, count, rtl }) => `
    max-height: 58px;
    min-height: 58px;
    height: 58px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: ${rtl ? 'row-reverse' : 'row'};
    background-color: ${theme.palette.N70.main};
    z-index: 9999;
    border-radius: 4px;
    ${count > 1 && `box-shadow: ${theme.palette.N80.main} 4px 4px 0 0`};
    position: relative;
  `}
`;
const IconsWrapper = styled(MuiBox) `
  height: 100%;
  position: relative;
  width: 42px;
  max-width: 42px;
  min-width: 42px;
`;
const Icons = styled(MuiBox) `
  ${({ rtl }) => `
    position: absolute;
    ${rtl ? 'right: 0' : 'left: 0'}px;
    top: 50%;
    transform: translateY(-50%);
    width: 42px;
    max-width: 42px;
    min-width: 42px;
    height: 100%;
    
    > span, svg {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      ${rtl ? 'right: 8px' : 'left: 6px'};
    }
    
    > svg {
      ${rtl ? 'right: 6px' : 'left: 6px'};
    }
 `}
`;
const Text = styled(MuiTypography, {
    shouldForwardProp: prop => !['rtl', 'enableCheckboxSelection'].includes(prop),
}) `
  ${({ rtl, enableCheckboxSelection }) => `
    ${rtl ? 'padding-left: 10px' : 'padding-right: 10px'};
    ${enableCheckboxSelection ? 'padding-right: 10px' : 'padding-left: 10px'};
    direction: ${rtl ? 'rtl' : 'ltr'};
  `}
`;
const PillContainer = styled(MuiBox, {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  ${({ rtl }) => `
    ${rtl ? 'padding-left: 10px' : 'padding-right: 10px'};
  `}
`;
const getShrinkInEffect = (initialOffset, width, offsetLeft) => {
    return keyframes `
    from {
      width: ${width}px;
      margin-left: -${(initialOffset === null || initialOffset === void 0 ? void 0 : initialOffset.x) - offsetLeft}px;
    }
    to {
      width: 180px;
      margin-left: 0;
    }
  `;
};
const getGrowOutEffect = (initialOffset, lastOffset, width, offsetLeft) => {
    return keyframes `
    from {
      opacity: 1;
      transform: translate(${lastOffset === null || lastOffset === void 0 ? void 0 : lastOffset.x}px, ${lastOffset === null || lastOffset === void 0 ? void 0 : lastOffset.y}px);
    }
    to {
      opacity: 0.5;
      transform: translate(${initialOffset === null || initialOffset === void 0 ? void 0 : initialOffset.x}px, ${initialOffset === null || initialOffset === void 0 ? void 0 : initialOffset.y}px);
      width: ${width}px;
      margin-left: -${(initialOffset === null || initialOffset === void 0 ? void 0 : initialOffset.x) - offsetLeft}px;
    }
  `;
};

export { Icons, IconsWrapper, PillContainer, Root, Text, getGrowOutEffect, getShrinkInEffect };
//# sourceMappingURL=styled.js.map
